import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@air/component-skeleton";
import { memo } from "react";
export const InfoPanelLoadingSkeleton = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-4 px-2 py-5",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 64,
                        height: 6
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 168,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 107,
                        height: 10
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-5",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 64,
                        height: 6
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 168,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 168,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 107,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 107,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 168,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 107,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 168,
                        height: 10
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        width: 107,
                        height: 10
                    })
                ]
            })
        ]
    });
});
InfoPanelLoadingSkeleton.displayName = "InfoPanelLoadingSkeleton";
